export const defaultState = {
  examSession: null,
  questions: [],
  answers: [],
  results: null,
  currentQuestionNo: 1,
};
